import { useAuthorizations } from '@/react/hooks/useUser';

import { WidgetBody, Widget } from '@@/Widget';

import { YAMLInspector } from '../../components/YAMLInspector';
import { useNodeQuery } from '../queries/useNodeQuery';

export function NodeYamlInspector({
  environmentId,
  nodeName,
}: {
  environmentId: number;
  nodeName: string;
}) {
  const nodeYamlQuery = useNodeQuery<string>(environmentId, nodeName, {
    isYaml: true,
  });
  const { authorized: isAuthorisedToEditNode } =
    useAuthorizations('K8sClusterNodeW');
  return (
    <Widget className="mx-4">
      <WidgetBody>
        <YAMLInspector
          identifier="node-yaml"
          data={nodeYamlQuery.data || ''}
          authorised={isAuthorisedToEditNode}
          data-cy="node-yaml"
          isLoading={nodeYamlQuery.isInitialLoading}
          isError={nodeYamlQuery.isError}
          hideMessage
          confirmMessage="Editing the node YAML can cause the node to become unschedulable, lose connectivity, or break workloads. Changes may be overwritten by Kubernetes and mistakes can disrupt your cluster. Are you sure you want to continue?"
        />
      </WidgetBody>
    </Widget>
  );
}
